import * as React from 'react';
import {AgGridReact} from 'ag-grid-react';
import {useMemo} from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {useSelector} from 'react-redux';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import {Box} from '@mui/system';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tooltip, Typography} from '@mui/material';
import {renderDateCell} from '@app/screens/configuration-management/components/expense-type-setting-grid';
import '../approve-expenses/styles/gridStyle.css';
import {strings} from '@app/common/strings';
import InfoIcon from '@mui/icons-material/Info';

export const ApproveExpenseExceptionSummaryGrid = () => {

    const [summaryPopup, setSummaryPopup] = React.useState(false);
    const [selectedSummary, setSelectedSummary] = React.useState('');

  const getAIColumnDisplayValue = (params: any) => {
    if (params?.data?.isWeekOff) {
      return ' ';
    }
    const value = params?.value;
    if (value === null || value === undefined || String(value).trim() === '') {
      return '-';
    }
    return value;
  };

  const renderNAIfEmpty = (params: any) => getAIColumnDisplayValue(params);
  
  const exceptionSummaryColumns: any = [
    {
      field: 'date',
      headerName: 'Date',
      width: 150,
      cellRenderer: (params: any) => {
        return renderDateCell(params?.data?.date);
      },
    },

    {field: 'expenseCategory', headerName: 'Expense Type', width: 150},

    {field: 'standard', headerName: 'Standard', width: 160},
    {field: 'claimed', headerName: 'Claimed', width: 140},
    {field: 'expenseType', headerName: 'Remarks', width: 200},
    {
      field: 'managerApprovedAmount',
      headerName: 'Manager Approved Amount',
      width: 170,
    },
    {
      headerName: 'Manager Remarks',

      field: 'managerReason',
      width: 250,
    },
    {
      headerName: 'AI DECISION',
      field: 'aiDecision',
      width: 250,
      cellRenderer: renderNAIfEmpty,
    },
     {
      headerName: 'AI AMOUNT PASSED',

      field: 'aiAmount',
      width: 100,
      cellRenderer: renderNAIfEmpty,
    }, {
      headerName: 'AI SUMMARY',

      field: 'aiSummary',
      width: 250,
      cellRenderer: (params: any) => {
        return renderExceptionSummary(params);
      },
      
    },
     {
      field: 'aiSummaryDetail',
      headerName: ' ',
      width: 40,
      cellRenderer: (params: any) => {
        const hasDetail = params?.data?.aiSummaryDetail && String(params?.data?.aiSummaryDetail).trim() !== '';
        return renderInfoCell(hasDetail ? params?.data?.aiSummaryDetail : null);
      },
    },
  ];

     const renderInfoCell = (params: any) => {
      const isDisabled = !params;
      return (
        <Box sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
          <IconButton
            size="small"
            disabled={isDisabled}
            onClick={() => {
              setSelectedSummary(params || '');
              setSummaryPopup(true);
            }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Box>
      );
    };
  
   const renderExceptionSummary = (params: any) => {
      const displayValue = getAIColumnDisplayValue(params);
      return (
        <Tooltip title={displayValue === 'N/A' || displayValue.trim() === '' ? '' : displayValue}>
          <span>{displayValue}</span>
        </Tooltip>
      );
    };
  
  const exceptionSummaryRows = useSelector(
    approveExpenseStateSelector.getExceptionSummaryData(),
  );

  const getRowId = useMemo(() => {
    return (params: any) => {
      return params?.data?.id;
    };
  }, []);

  const columnTypes = React.useMemo(() => {
    return {
      valueColumn: {
        editable: true,
        valueParser: 'newValue',
      },
    };
  }, []);

  return (
    <>
      {exceptionSummaryRows?.length === 0 && (
        <Box
          sx={{
            border: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 10,
              mb: 10,
              mr: 10,
              ml: 10,
            }}>
            <Typography>{strings.noRecordFound}</Typography>
          </Box>
        </Box>
      )}
      {exceptionSummaryRows?.length > 0 && (
        <div className="ag-theme-alpine" style={{height: 460, width: '100%'}}>
          <AgGridReact
            rowData={exceptionSummaryRows}
            columnDefs={exceptionSummaryColumns}
            getRowId={getRowId}
            columnTypes={columnTypes}
            editType={'fullRow'}
            rowHeight={30}
            headerHeight={40} // column header height set to 40px
            defaultColDef={{
              sortable: true,
              cellDataType: false,
              resizable: true,
              suppressMovable: true,
              wrapText: false,
              autoHeight: false,
            }}
          />
        </div>
      )}
      {<Dialog
              open={summaryPopup}
              onClose={() => setSummaryPopup(false)}
              maxWidth="sm"
              fullWidth>
              <DialogTitle>{strings.ModuleSpecificUtilitie.approveExpense.aiSummary}</DialogTitle>
              <DialogContent>
                <DialogContentText sx={{whiteSpace: 'pre-wrap'}}>
                  {selectedSummary || '-'}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setSummaryPopup(false)} variant="contained" size="small">
                  {strings.close}
                </Button>
              </DialogActions>
            </Dialog>}
    </>
  );
};
